module.exports = __webpack_public_path__ + "img/fmk-environment.65c32843.jpg";